export const GUARDS_FORM = [
  {
    name: "name",
    type: "text",
    placeholder: "Name",
    label: "Name :",
    required: true,
  },
  {
    name: "username",
    type: "text",
    placeholder: "User Name",
    label: "User Name :",
    required: true,
  },
  {
    name: "password",
    type: "password",
    placeholder: "Password",
    label: "Password :",
    required: true,
  },
  {
    name: "contactNumber",
    type: "text",
    placeholder: "Contact Number",
    label: "Contact Number :",
    required: true,
  },
  // {
  //   name: "assignedBuilding",
  //   type: "dropdown",
  //   placeholder: "Assigned Building",
  //   label: "Assigned Building :",
  //   required: true,
  // },
  {
    name: "shiftStartTime",
    type: "time",
    placeholder: "Shift Start Time",
    label: "Shift Start :",
    required: true,
  },
  {
    name: "shiftEndTime",
    type: "time",
    placeholder: "Shift End Time",
    label: "Shift End :",
    required: true,
  },
];
